import { render, staticRenderFns } from "./RechargeForm.vue?vue&type=template&id=0f0cf4be"
import script from "./RechargeForm.vue?vue&type=script&lang=js"
export * from "./RechargeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports